import { ValidationError } from "sequelize"
import {
    MtStudy,
    MtStudyCreate,
    MtStudySave,
} from "server/models"
import { OrderType } from "client/utils"
import {
    GET, POST, DELETE, sort, search, validate,
} from "client/store/utils"
import {
    LangType,
    StudyList,
    StudyValidation,
    StudyFilters,
} from "client/store"

export const LoadAllStudies = (projectId: number) => (
    GET(`/mtStudy/projectId/${projectId}`)
    .then((studies: MtStudy[]) => {
        const studyList: StudyList = {}
        studies.forEach((study) => {
            studyList[study.id] = study
        })
        return studyList
    })
)

export const LoadStudyById = (studyId: number, projectId: number) => (
    GET(`/mtStudy/id/${studyId}/projectId/${projectId}`)
    .then((study: MtStudy) => study)
)

export const SaveStudy = (
    id: number,
    study: MtStudyCreate,
    lang: LangType,
) => {
    const data: MtStudySave = {
        id,
        study,
    }
    return POST(
        "/mtStudy/save",
        JSON.stringify(data),
    ).then((res) => {
        const newStudy = res as MtStudy
        const error = res as ValidationError

        return {
            newStudyId: newStudy.id || null,
            validation: <StudyValidation>validate(error, lang),
        }
    })
}

export const DeleteStudy = (studyId: number, projectId: number) => (
    DELETE(`/mtStudy/delete/${studyId}/${projectId}`)
    .then((removedRows: number) => removedRows)
)

export const SortStudies = (
    studies: MtStudy[],
    sortColumn: keyof MtStudy,
    sortOrder: OrderType,
    filters: StudyFilters,
): number[] => {
    const studiesFiltered = studies.filter((study) => {
        let showRow = true
        if (filters.search) showRow = search(filters.search, study)
        return showRow
    })

    const studyIds: number[] = []
    studiesFiltered.sort((a, b) => sort(a, b, sortColumn, sortOrder))
    studiesFiltered.forEach((study) => studyIds.push(study.id))

    return studyIds
}
